import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BasicCard from '../../../../../components/card/basiccard/BasicCard';
import TextInput from '../../../../../components/input/textinput/TextInput';
import { HEADING } from '../../../../../components/heading/constants/constants';
import Heading from '../../../../../components/heading/Heading';
import { VEC_ICON_NAME } from '../../../../../components/icons/constants';
import Icons from '../../../../../components/icons/Icons';
import { CREATE_FORMS_LOADING_STATES, CREATE_FORM_STATES_MESSAGE_MAP, PAYER_TYPE, RECIPIENT_ID_TYPE, RECORDS_TO_SHOW_PER_PAGE } from '../../constants';
import { getRecipient, getRecipientList } from '../../CreateFormSaga';
import { componentKey, setStepperRefreshStep, setToCreateFormData } from '../../CreateFormSlice';
import { componentKey as authenticationComponentKey } from '../../../../authentication/AuthenticationSlice';
import styles from './SelectRecipient.styles';
import RenderInteractionElement from '../components/RenderInteractionElement';
import Button from '../../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../../components/button/constants';
import AddRecipient from '../../../../components/addrecipientnew/AddRecipient';
import FormEventHandlers from '../../../../../../libs/utility/formeventhandlers/FormEventHandlers';
import Loadable from '../../../../../components/loadable/Loadable';
import { FORM_NAMES, QUERY_PARAMS } from '../../../constants';
import EditRecipient from '../../../../components/addrecipientnew/editrecipient/EditRecipient';
import '../directcss/common.scss';
import { addNotifications } from '../../../../toaster/ToasterPortalSlice';
import Pagination from '../../../../../components/richgrid/Pagination';
import { TOASTER_VARIANT } from '../../../../../components/toast/constants';
import General from '../../../../../../libs/utility/General';
import useTxSearchParams from '../../../../../../libs/txsearchparams/TxSearchParamsHook';
import { ROW_SELECTION_OPTIONS } from '../../../../../components/richgrid/constants';

export default function SelectRecipient() {

    const { loadingState, recipientListLoadingState, recipientList, toCreateFormData, userInteractionPopupWResponseObj, formsPreLoadedData, stepperRefreshStep } = useSelector((state) => state[componentKey]);
    const { signedInUser } = useSelector(state => state[authenticationComponentKey]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isAddPayeeModalOpen, setIsAddPayeeModalOpen] = useState(false);
    const [isEditPayeeModalOpen, setIsEditPayeeModalOpen] = useState(false);
    const [payeeIdForEdit, setPayeeIdForEdit] = useState(null);
    const [is1042SForm, setIs1042SForm] = useState(false);
    const [visibleRecipientsInViewPort, setVisibleRecipientsInViewPort] = useState([]);
    const [paginationState, setPaginationState] = useState({
        currentPage: 1,
        pageSize: RECORDS_TO_SHOW_PER_PAGE,
        skip: 0,
    });
    const [reorderedRecipientList, setReorderedRecipientList] = useState([])

    const dispatch = useDispatch();
    const [queryParams,setQueryParams] = useTxSearchParams();

    useEffect(()=>{
        setReorderedRecipientList(recipientList.data)
    },[recipientList])

    useEffect(() => {
        const reorderedRecipientList = General.reorderArrayByActiveElementObj(recipientList.data, "RecipentDetailId", toCreateFormData?.selectedRecipient?.RecipentDetailId)
        setReorderedRecipientList(reorderedRecipientList)
    }, [stepperRefreshStep, recipientList])

    const filteredRecipients = useMemo(() => {
        setPaginationState({...paginationState, currentPage: 1, skip: 0});
        return reorderedRecipientList.filter((recipient) => {
            if (recipient.Name.toLowerCase().includes(searchTerm.toLowerCase())) {
                return recipient;
            }
        });
    }, [searchTerm, reorderedRecipientList]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleRecipientSelection = (recipient) => {
        if(recipient?.TinStatus !== undefined && recipient.TinStatus === "Blocked"){
            dispatch(addNotifications({ 
                heading: "Recipient TIN Verficaiton failed", 
                message: "Please select a differnt recipient or initiate a TIN verification for this recipient before proceeding forward.",
                variant: TOASTER_VARIANT.DANGER  }))
        }
        else if(recipient.hasOwnProperty("IsActive") && !recipient?.IsActive){
            dispatch(addNotifications({ heading: "Selected recipient is In-Active", message: "Please select an active recipient" }))
        }else{
            dispatch(getRecipient(recipient.RecipentDetailId));
        }
    }

    const handleOnNewAddedRecipientSuccess = (toCreateFormData, editRecipientModeOn = false, editedPayeeId = null) => {
        FormEventHandlers.updateOnPayerSelectAndFormSelect(toCreateFormData, (requestData) => dispatch(getRecipientList(requestData)), formsPreLoadedData, (data) => dispatch(setToCreateFormData(data)), false, false, editRecipientModeOn, () => dispatch(getRecipient(editedPayeeId)));
    }

    const editPayeeBtnClk = (e, payeeId) => {
        e.stopPropagation();
        setPayeeIdForEdit(payeeId);
        setIsEditPayeeModalOpen(true);
    }
    useEffect(() => {
        setIs1042SForm(toCreateFormData?.selectedForm?.FormId === FORM_NAMES.FORM1042S);
    }, [toCreateFormData?.selectedForm?.FormId]);


    useEffect(() => {
        const startIndex = (paginationState.currentPage - 1) * paginationState.pageSize;
        let paginatedRecords = filteredRecipients.slice(startIndex, startIndex + paginationState.pageSize);
        setVisibleRecipientsInViewPort(paginatedRecords);
    }, [paginationState.currentPage, paginationState.pageSize, filteredRecipients, toCreateFormData?.selectedRecipient]);

    
    const onClickNextBtn = () => {
        dispatch(setStepperRefreshStep(2))
    }

    return <>
        <Loadable 
            currentState={recipientListLoadingState.state} 
            messageMap={CREATE_FORM_STATES_MESSAGE_MAP}
            loadingStates={[CREATE_FORMS_LOADING_STATES.RECIPIENT_PAGE_LOADING]} 
            isNewLoadable={true}
            preserveChildMount={true}
        >
            <Loadable 
                currentState={loadingState.state} 
                messageMap={CREATE_FORM_STATES_MESSAGE_MAP}
                loadingStates={[CREATE_FORMS_LOADING_STATES.RECIPIENT_PAGE_LOADING, CREATE_FORMS_LOADING_STATES.DEPENDENT_FIELD_CHANGE_LOADING, CREATE_FORMS_LOADING_STATES.SAVING_FORM_LOADING]} 
                isNewLoadable={true}
                preserveChildMount={true}
            >
                <div style={styles.mainContainer}>
                    <div style={styles.titleRow}>
                        <div style={styles.headerTitle}>
                            <Heading type={HEADING.H1} >
                            {signedInUser?.FirstName}, for which recipient are you eFiling this form?
                            </Heading>
                        </div>
                        <div style={styles.progressIndicator}>
                        </div>
                    </div>
                    <div style={styles.searchAndAddNewRecipientContainer}>
                        <div style={styles.recipientListActionRow}>
                            <TextInput
                                name="searchRecipient"
                                type="text"
                                value={searchTerm}
                                placeHolder='Search by recipient name...'
                                onChangeCb={handleSearchChange}
                                suffixProps={{ icon: VEC_ICON_NAME.SEARCH_ICON }}
                            />
                        </div>
                        <div style={styles.titleSubTextContainer}>
                            <span style={styles.titleSubText}>
                                Need to add a new recipient?
                            </span>
                            <span>
                                <Button
                                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                    onClickCb={() => setIsAddPayeeModalOpen(true)}
                                    style={styles.fontWeight600}
                                >
                                    Add recipient
                                </Button>
                            </span>
                        </div>
                    </div>
                    <div style={styles.recipientListContainer}>
                        <div style={styles.recipientList}>
                            {
                                (filteredRecipients.length > 0) ? 
                                visibleRecipientsInViewPort.map(recipient => {
                                        return <MemoizedBasicCard
                                            key={recipient.RecipentDetailId}
                                            recipient={recipient}
                                            editPayeeBtnClk={editPayeeBtnClk}
                                            toCreateFormData={toCreateFormData}
                                            handleRecipientSelection={handleRecipientSelection}
                                            onClickNextBtn={onClickNextBtn}
                                        />
                                    })
                                :   <p>No recipients matching with the searched term</p>
                            }
                        </div>
                        {
                            (filteredRecipients.length > 0) ? <div>
                                <Pagination
                                    skip={paginationState.skip}
                                    take={paginationState.pageSize}
                                    total={filteredRecipients.length}
                                    takeOptions={ROW_SELECTION_OPTIONS}
                                    onChange={(take, t) => {
                                        setPaginationState({...paginationState, skip: t, currentPage: Math.ceil((take + t) / take)})
                                    }}
                                    onChangeTakeCb={(newTake) => {
                                        setPaginationState({ ...paginationState, pageSize: newTake, currentPage: 1, skip: 0 })
                                    }}
                                />
                            </div>
                            : null
                        }
                    </div>
                </div>
            </Loadable>
        </Loadable>
        {(userInteractionPopupWResponseObj?.type) ? <RenderInteractionElement interactionObj={userInteractionPopupWResponseObj}  userInteractionPopupWResponseObj={userInteractionPopupWResponseObj}/> : null}
        {isAddPayeeModalOpen && <AddRecipient isPopup={true} isPopupOpen={isAddPayeeModalOpen} onPopupCloseCb={() => setIsAddPayeeModalOpen(false)} onFinalSubmitCb={() => handleOnNewAddedRecipientSuccess(toCreateFormData, false)} defaultSelectedPayer={toCreateFormData?.selectedPayer} hidePayerSelectionStep={true} is1042SForm={is1042SForm} fromFormModule={true} />}
        {isEditPayeeModalOpen && <EditRecipient recipientID={payeeIdForEdit} isPopup={true} isPopupOpen={isEditPayeeModalOpen} onPopupCloseCb={() => setIsEditPayeeModalOpen(false)} onFinalSubmitCb={() => handleOnNewAddedRecipientSuccess(toCreateFormData, true, payeeIdForEdit)} is1042SForm={is1042SForm} fromFormModule={true} />}
    </>
}

const MemoizedBasicCard = React.memo(({ recipient, editPayeeBtnClk, toCreateFormData, handleRecipientSelection, onClickNextBtn }) => {
    const recipientCardStyles = useMemo(() => styles.recipientCardCustomStyles, []);
    const dispatch = useDispatch();

    return (
        <BasicCard customStyles={recipientCardStyles} isHighlighted={toCreateFormData?.selectedRecipient?.RecipentDetailId === recipient.RecipentDetailId} circularCheckboxStyles={styles.activeIconStyle}>
            <div onClick={() => handleRecipientSelection(recipient)} style={styles.singleRecipientContainer} className={"selectPayerRecipientCardContainer"}>
                <Icons familyName="vec" iconName={(recipient.IdType == (RECIPIENT_ID_TYPE.INDIVIDUAL || RECIPIENT_ID_TYPE.SSN)) ? VEC_ICON_NAME.PAYER_TYPE_INDIVIDUAL_SMALL : VEC_ICON_NAME.PAYER_TYPE_BUSINESS_SMALL} />
                <div style={styles.recipientInfo}>
                    <span style={styles.recipientLabel} title={General.displayPayerRecipientName(recipient)}>{General.truncateWithEllipsis(General.displayPayerRecipientName(recipient), 17)}</span>
                    <span className={"editPayerRecipientBtn"}>    
                        <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={'Edit Recipient'} onClickCb={(e) => editPayeeBtnClk(e, recipient?.RecipentDetailId)}>
                            <Icons familyName={'vec'} iconName={VEC_ICON_NAME.EDIT_ICON} />
                        </Button>
                    </span>
                </div>
                {toCreateFormData?.selectedRecipient?.RecipentDetailId === recipient.RecipentDetailId ?
                    <span style={styles.recipientCardNextButton}>
                        <Button
                            style={styles.selectAndNextBtn}
                            onClickCb={(e) => {
                                e.stopPropagation()
                                onClickNextBtn(recipient)
                            }}
                        >
                            Next
                        </Button>
                    </span>
                    :
                    <span style={styles.recipientCardNextButton} className={"selectAndNextBtn"}>
                        <Button style={styles.selectAndNextBtn} onClickCb={() => onClickNextBtn(recipient)}>Select & Next</Button>
                    </span>
                }
            </div>
        </BasicCard>
    );
});